import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { DialogService, DynamicFieldService, JobApiService, StudentApiService } from '@agent-ds/shared/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
// import { CounselingMemoUploadType as UploadType } from '@agent-ds/shared/enums';
import { Job, JobScreeningInfo, StudentDetail } from '@agent-ds/shared/interfaces';
import { DynamicField, FormMeta } from '@agent-ds/shared/models';
import { Subscription } from 'rxjs';
import {
  JobScreeningInfoType,
  JobScreeningInfoTypes
} from '@agent-ds/shared/interfaces';
// import { CounselingMemoConfirmDialogComponent } from '@agent-ds/student/components/counseling-memo-confirm-dialog/counseling-memo-confirm-dialog.component';
// import { SituationMemo, CounselingMemo } from '@agent-ds/shared/interfaces/memo';

@Component({
  selector: 'ag-job-screening-info-create-dialog',
  templateUrl: './job-screening-info-create-dialog.component.html',
  styleUrls: ['./job-screening-info-create-dialog.component.scss'],
})
export class JobScreeningInfoCreateDialogComponent implements OnInit, OnDestroy {
  constructor(
    private dialogService: DialogService,
    private dynamicService: DynamicFieldService,
    private jobApiService: JobApiService,
    public dialog: DialogRef,
    public config: DialogConfig<{ job: Job }>,
  ) {}

  saving: boolean = false;
  job: Job;
  jobScreeningInfoData: JobScreeningInfo = new JobScreeningInfo();
  jobScreeningInfoDataModel: {
    jobScreeningInfo: JobScreeningInfo
  } = {
    jobScreeningInfo: this.jobScreeningInfoData
  };
  jobScreeningInfoMeta: FormMeta;
  private fieldSubscription: Subscription;

  ngOnInit() {
    this.job = this.config.data.job;
    this.fieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      this.initFieldsMeta();
    });
  }

  ngOnDestroy() {
    if(this.fieldSubscription) {
      this.fieldSubscription.unsubscribe();
      this.fieldSubscription = null;
    }
  }

  private initFieldsMeta() {
    this.jobScreeningInfoMeta = {
      disabled: false,
      initTouched: true,
      groups: [
        {
          title: '新規サブステータス情報',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(
              {
                fieldName: 'type',
                fieldType: 'list',
                label: '選考情報',
                displayType: 'dropdown',
                validationStyle: {
                  required: true,
                  options: [
                    ...(
                      Object.values(JobScreeningInfoTypes)
                    ),
                  ],
                },
              },
              'jobScreeningInfo',
              'full',
            ),
            ...this.dynamicService.getFormRows(
              {
                "model": "job",
                "fieldName": "jobScreeningInfo",
                "fieldType": "screening-info",
                "label": "サブステータス情報",
                "isCustomField": false,
                "displayType": "screening-info",
                "displayStyle": {},
                "isSearchable": false,
                "validationStyle": {},
                "searchStyle": {},
                "unit": ""
              }
            ),
          ],
        },
      ],
    };
  }

  public isValidJobScreeningInfoData(): boolean {
    return !!this.jobScreeningInfoData.type;
  }

  public close(): void {
    this.dialog.close();
  }

  public reflect(): void {
    if (!this.isValidJobScreeningInfoData() || !this.job || !this.job.id) {
      // 必須の type が未選択
      return;
    }
    if (this.saving) return;
    this.saving = true;

    const payload: any = {
      ...this.jobScreeningInfoData,
      // deadline は number|null に寄せる（dynamic form が '' を返すケース対策）
      request1Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request1Deadline),
      request2Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request2Deadline),
      request3Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request3Deadline),
    };

    this.jobApiService.createJobScreeningInfo(this.job.id, payload).subscribe(
      () => {
        this.saving = false;
        // 親側で拾えるように返す（必要なら）
        this.dialog.close({ saved: true });
        // もし一覧の再取得を JobDetail 側でやりたいなら afterClosed で fetch してください
      },
      () => {
        this.saving = false;
      },
    );
  }

  private toNullableInt(v: any): number | null {
    if (v === '' || v === undefined || v === null) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
}
